export default {
  getHead: () => {
    return [{name: '사업장(현장)명'}, {name: '안전관리자'}, {name: '보건관리자'}, {name: '산업보건의'}, {name: '소속명'}, {name: '팀명'}, {name: '작성일'}]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).inputC_1 // 사업장(현장)명
      case 1: return func.getContent(value).inputD_1 // 안전관리자
      case 2: return func.getContent(value).inputE_1 // 보건관리자
      case 3: return func.getContent(value).inputF_1 // 산업보건의
      case 4: return func.getContent(value).stdInfo.department // 소속명
      case 5: return func.getContent(value).stdInfo.section // 부서명
      case 6: return func.getCreatedDate(value.created_at) // 작성일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    switch (nav.value.searchType) {
    case '사업장명': return ['content$body.inputC_1*%[:default_skw]%']
    case '안전관리자': return ['content$body.inputD_1*%[:default_skw]%']
    case '보건관리자': return ['content$body.inputE_1*%[:default_skw]%']
    case '산업보건의': return ['content$body.inputF_1*%[:default_skw]%']
    case '소속명': return ['content$body.stdInfo.department*%[:default_skw]%']
    case '부서명': return ['content$body.stdInfo.section*%[:default_skw]%']
    case '작성자': return ['content$body.stdInfo.writer_name*%[:default_skw]%']
    }
  },
}
